import { withLocale } from 'op/components/locale';
import { withReportSignatures } from "op/components/report/signature/report-signature.helper";
import SignatureModal from "op/components/report/signature/signature-modal/signature-modal.component";
import StpFormSubmitModal from './submit-modal/submit-modal.component';
import ValidationErrorModal from './submit-modal/validation-error-modal.component';
import ValidationSuccessModal from './submit-modal/validation-success-modal.component';
import React, { useCallback } from "react";
import ReactDatePicker from "react-datepicker";
import { useForm } from "react-hook-form";
import { hot } from "react-hot-loader";
import { compose } from "recompose";
import { connect } from 'react-redux';
import { Button, ButtonContent, Icon, Card, Checkbox, Form, FormField, Grid, Header, Input, Label, TextArea } from "semantic-ui-react";
import styled from "styled-components";
import PopUpInfo from "./popupinfo.component";
import Test12 from "./tests-components/Test12";
import Test3 from "./tests-components/Test3";
import Test4 from "./tests-components/Test4";
import Test5 from "./tests-components/Test5";
import Test6 from "./tests-components/Test6";
import DomToImage from 'dom-to-image';
import { useMemo, useEffect } from 'react';
import { useHistory } from 'react-router';
import { selectSystemSettings } from '../../../../redux/reducers/system-settings/system-settings.selectors';

const Collapsible = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;  
    align-items: center;
    background-color: white;
`;

const CollapsibleColumn = styled.div`
    flex: 1;
`;

const CardForSignature = styled(Card)`
    :first-child {
        border: solid 2px blue !important;
    }
`;

const BoldText = styled.p`
    font-weight: bold;
    width: fit-content;
    display: inline-block;
    margin: 0;
    font-size: 1.2rem;
`;

const StyledIcon = styled(Icon)`
  width: 15.75px !important;
  height: 14.4px !important;
  font-size: 15.75px !important;
  line-height: 14.4px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
`;

const ExclamationIcon = ({ color = "red" }) => {
  return <StyledIcon name="exclamation circle" color={color} />;
};

const getViewLabel = (view) => {
    switch (view.STPTestView) {
        case 1:
            return 'Single View';
        case 2:
            return 'Horizontal';
        case 3:
            return 'Vertical';
        default:
            return 'Single View';
    }
};

const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func(...args), delay);
    };
};

const StpForm = ({
    manufacturer,
    model,
    serialNumber,
    location,
    type,
    user,
    itemId,
    report,
    registerSignatrue,
    saveSignatrues,
    validateForm,
    onSubmit,
    locale,
    stpForm,
    setStpForm,
    systemSettings,
}) => {
    const history = useHistory();
    const [isValidating, setIsValidating] = React.useState(false);
    const [showValidationError, setShowValidationError] = React.useState(false);
    const [showValidationSuccess, setShowValidationSuccess] = React.useState(false)
    const [isFormValid, setIsFormValid] = React.useState(true);
    const [isMandatoryComment, setIsMandatoryComment] = React.useState(false);

    const stpmaindate = new Date(stpForm.data[0].STPMainDate);
    const stmmaincomments = stpForm.data[0].STPMainComments;
    const stpmainposition = stpForm.data[0].STPMainPosition;
    const stpemailalert = stpForm.data[0].STPEmailAlert;

    const [localComments, setLocalComments] = React.useState(stmmaincomments || "");

    useEffect(() => {
        if (systemSettings.isMaintRemarkForFailure && !isFormValid) {
            const isCommentMissing = !localComments || localComments.trim() === "";
            setIsMandatoryComment(isCommentMissing);
        } else {
            setIsMandatoryComment(false);
        }
    }, [isFormValid, localComments, systemSettings.isMaintRemarkForFailure]);

    const grabScreenshotsAndDateString = async () => {
        const localHours = stpmaindate.getHours();
        const localMinutes = stpmaindate.getMinutes();
        const localDay = stpmaindate.getDate();
        const localMonth = stpmaindate.getMonth() + 1;
        const localYear = stpmaindate.getFullYear();

        let stpData = [...stpForm.data];

        const STPMainDate = `${localYear}-${localMonth}-${localDay} ${localHours}:${localMinutes}`;

        stpData = await Promise.all(stpData.map(async (view) => {
            const CardView = document.getElementById(`${view.STPTestView}testview`);

            const Test12View = document.getElementById(`${view.STPTestView}testview_test12`);
            const Test3View = document.getElementById(`${view.STPTestView}testview_test3`);
            const Test4View = document.getElementById(`${view.STPTestView}testview_test4`);
            const Test5View = document.getElementById(`${view.STPTestView}testview_test5`);
            const Test6View = document.getElementById(`${view.STPTestView}testview_test6`);

            const testScreenshot = (await DomToImage.toPng(CardView, {
                width: 900,
                height: 800,
            })).replace('data:image/png;base64,', '');

            const [
                STPTest12Screenshot,
                STPTest3Screenshot,
                STPTest4Screenshot,
                STPTest5Screenshot,
                STPTest6Screenshot,
            ] = await Promise.all([
                DomToImage.toPng(Test12View).then(res => res.replace('data:image/png;base64,', '')),
                DomToImage.toPng(Test3View).then(res => res.replace('data:image/png;base64,', '')),
                DomToImage.toPng(Test4View).then(res => res.replace('data:image/png;base64,', '')),
                DomToImage.toPng(Test5View).then(res => res.replace('data:image/png;base64,', '')),
                DomToImage.toPng(Test6View).then(res => res.replace('data:image/png;base64,', '')),
            ]);

            return {
                ...view,
                STPMainDate,
                STPMainComments: localComments,
                STPMainPosition: stpmainposition,
                STPEmailAlert: stpemailalert,
                STPTest12Screenshot,
                STPTest3Screenshot,
                STPTest4Screenshot,
                STPTest5Screenshot,
                STPTest6Screenshot,
                STPMainReportFile: testScreenshot,
            }
        }));

        return stpData;
    };
    const validateSave = useMemo(() => ({
        
        ok: Object.keys(report.signatures).length > 0 && !isMandatoryComment, 
        message: 'Please sign the form and fill the mandatory comment',
    }), [report, isMandatoryComment, isFormValid]);
    
    const validateValidation = useMemo(() => ({
        ok: Object.keys(report.signatures).length > 0, 
        message: 'Please sign the form',
    }), [report]);
    
    const formRef = React.useRef();

    const updateDateTime = useCallback((newDateTime) => {
        setStpForm((prev) => {
            const newStpForm = { ...prev }

            newStpForm.data.forEach((item) => {
                item.STPMainDate = newDateTime;
            });

            return newStpForm;
        });
    }, []);

    const debouncedUpdateStpForm = useCallback(
        debounce((newComment) => {
            setStpForm((prev) => {
                const newStpForm = { ...prev };
                newStpForm.data.forEach((item) => {
                    item.STPMainComments = newComment;
                });
                return newStpForm;
            });
        }, 500),
        []
    );


    const handleCommentsChange = useCallback((newComment) => {
        setLocalComments(newComment);
        debouncedUpdateStpForm(newComment);
    }, [debouncedUpdateStpForm]);

    const updateMainPosition = useCallback((newMainPosition) => {
        setStpForm((prev) => {
            const newStpForm = { ...prev };

            newStpForm.data.forEach((item) => {
                item.STPMainPosition = newMainPosition;
            });

            return newStpForm;
        });
    }, []);

    const updateSendEmail = useCallback((newSendEmail) => {
        setStpForm((prev) => {
            const newStpForm = { ...prev };

            newStpForm.data.forEach((item) => {
                item.STPEmailAlert = newSendEmail;
            });

            return newStpForm;
        });
    }, []);

    return (
        <Form
            ref={formRef}
        >
            <Card fluid>
                <Card.Content>
                    <FormField>
                        <label>{locale.testersName}</label>
                        <BoldText>{`${user.firstName.toUpperCase()} ${user.lastName.toUpperCase()}`}</BoldText>
                    </FormField>
                    <FormField>
                        <label>{locale.dateTime}</label>
                        <ReactDatePicker
                            name='STPMainDate'
                            showTimeSelect
                            dateFormat="dd/MM/yyyy HH:mm"
                            selected={stpmaindate}
                            onChange={updateDateTime}
                            timeFormat="HH:mm"
                        />
                    </FormField>
                </Card.Content>
            </Card>
            <Card fluid>
                <Card.Content>
                    <Grid columns={2}>
                        <Grid.Column>
                            <FormField>
                                <label>{locale.manufacturer}</label>
                                <BoldText>{manufacturer.toUpperCase()}</BoldText>
                            </FormField>
                        </Grid.Column>
                        <Grid.Column>
                            <FormField>
                                <label>{locale.model}</label>
                                <BoldText>{model.toUpperCase()}</BoldText>
                            </FormField>
                        </Grid.Column>
                    </Grid>
                    <Grid columns={2}>
                        <Grid.Column>
                            <FormField>
                                <label>{locale.serial}</label>
                                <BoldText>{serialNumber.toUpperCase()}</BoldText>
                            </FormField>
                        </Grid.Column>
                        <Grid.Column>
                            <FormField>
                                <label>{locale.location}</label>
                                <BoldText>{location.toUpperCase()}</BoldText>
                            </FormField>
                        </Grid.Column>
                    </Grid>
                    <Grid columns={1}>
                        <Grid.Column>
                            <FormField>
                                <label>{locale.optimumSTP}</label>
                                <Input
                                    name="STPMainPosition"
                                    fluid
                                    value={stpmainposition}
                                    onChange={(e, { value }) => updateMainPosition(value)}
                                />
                            </FormField>
                        </Grid.Column>
                    </Grid>
                </Card.Content>
            </Card>
            {
                stpForm.data.map((view, index) => (
                    <Card fluid key={index}>
                        <Label attached='top'>
                            <BoldText>{
                                getViewLabel(view)
                            }</BoldText>
                            <PopUpInfo />
                        </Label>
                        <Card.Content
                            className='content-padded-from-top  '
                        >
                            <Collapsible
                                id={`${view.STPTestView}testview`}
                            >
                                <CollapsibleColumn>
                                    <Header>{locale.test12}</Header>
                                    <Test12 view={view} setStpForm={setStpForm} id={`${view.STPTestView}testview_test12`} />
                                    <Header>{locale.test3}</Header>
                                    <Test3 view={view} setStpForm={setStpForm} id={`${view.STPTestView}testview_test3`} />
                                    <Header>{locale.test4}</Header>
                                    <Test4 view={view} setStpForm={setStpForm} id={`${view.STPTestView}testview_test4`} />
                                </CollapsibleColumn>
                                <CollapsibleColumn>
                                    <Header>{locale.test5}</Header>
                                    <Test5 view={view} setStpForm={setStpForm} id={`${view.STPTestView}testview_test5`} />
                                    <Header>{locale.test6}</Header>
                                    <Test6 view={view} setStpForm={setStpForm} id={`${view.STPTestView}testview_test6`} />
                                </CollapsibleColumn>
                            </Collapsible>
                        </Card.Content>
                    </Card>
                ))
            }
            <Card fluid>
                <Card.Content>
                    <FormField>
                        <label>
                            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                {locale.comments}
                                {systemSettings.isMaintRemarkForFailure 
                                    && isMandatoryComment
                                    ? <ExclamationIcon /> 
                                    : null}
                            </div>
                        </label>
                        <TextArea
                            name='comments'
                            placeholder='Comments'
                            onChange={(e, { value }) => handleCommentsChange(value)}
                            value={localComments}
                        />
                    </FormField>
                </Card.Content>
            </Card>
            <Header>{locale.signature}</Header>
            <CardForSignature fluid>
                <div>
                    <SignatureModal
                        report={report}
                        registerSignatrue={registerSignatrue}
                        saveSignatrues={saveSignatrues}
                        type='EmpSig'
                        color='blue'
                    />
                </div>
            </CardForSignature>
            <Checkbox
                label={locale.sendMail}
                style={{ marginBottom: '1rem' }}
                name="STPEmailAlert"
                value={stpemailalert}
                checked={stpemailalert}
                onChange={(e, { checked }) => updateSendEmail(checked)}
            />
            <div>
                <StpFormSubmitModal
                    validation={validateSave}
                    onSave={() => {
                        history.push(`pending`);
                    }}
                    validate={async () => {
                        const values = await grabScreenshotsAndDateString();
                        const result = await validateForm(values);
                        return result;
                    }}
                    onSubmit={async () => {
                        const values = await grabScreenshotsAndDateString();
                        await onSubmit(values, stpForm.id);
                    }}
                    onRequestExit={() => {
                        window.location.href = `/stp/${itemId}/tests`;
                    }}
                />
                <ValidationErrorModal
                    open={showValidationError}
                    onClose={() => setShowValidationError(false)}
                />
                <ValidationSuccessModal
                    open={showValidationSuccess}
                    onClose={() => setShowValidationSuccess(false)}
                />
                <Button
                    type='button'
                    disabled={!validateValidation.ok}
                    onClick={async () => {
                        setIsValidating(true);
                        const values = await grabScreenshotsAndDateString();
                        const isValid = await validateForm(values);
                        
                        if (!isValid) {
                            setShowValidationError(true);
                        } else {
                            setShowValidationSuccess(true);
                            setTimeout(() => setShowValidationSuccess(false), 3000);
                        }
                        setIsFormValid(isValid)
                        setIsValidating(false);
                    }}
                    loading={isValidating}
                >
                    <ButtonContent>
                        {showValidationSuccess ? locale.validationSuccess : locale.validate_form}
                    </ButtonContent>
                </Button>
            </div>
        </Form>
    );
}

const mapStateToProps = (state) => ({
    systemSettings: selectSystemSettings(state)
});

export default compose(
    connect(mapStateToProps),
    withReportSignatures,
    hot(module),
    withLocale('stp.form'),
)(StpForm);
